/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
let datataskurl = root.dataTaskUrl.link;
import Vue from 'vue'
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    // Delete Data Well List
    deleteDataTaskFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.delete(datataskurl + payload.id + '/').then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
  },
  getters: {
  }
}